export const CF_INTRODUCTION_DATE = new Date("1973-09-29");
